type Props = {
  label: string
  value: string
}

export function InheritanceTooltipRow({ label, value }: Props) {
  return (
    <tr className="border border-gray-100 dark:border-gray-600">
      <td className="px-2 font-bold">{label}</td>
      <td>{value}</td>
    </tr>
  )
}
